import React from 'react';
import ReactDOM from 'react-dom';

class CoachLink extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachOrgId: props.route.coachOrgId
    };
  }

  componentDidMount = () => {
    this.props.actions.paymentActions.fetchProductInfo(this.state.coachOrgId);

    if(this.props.route.tabTitle) {
      document.title = this.props.route.tabTitle;
    }
  };

  onClickApp = () => {
    if (this.props.siteCheckout && this.props.siteCheckout.get("deepLink")) {
      window.open(this.props.siteCheckout.get("deepLink"), "_blank");
    }
  };
  renderHeader = () => {
    let sectionsClass = "navbar-section";
    if (this.props.route.navBarColor === "trybe-black") {
      sectionsClass = "navbar-section-black";
    }

    return (
      <div className={sectionsClass}>
        <div className="navbar-content">
          <div className="logo-container">
            <img
              className="logo-img"
              src={require("../../images/trybe-logo-white.svg")}
            />
            <div className="logo-text">TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  renderLogo = () => {
    return (
      <div className='creator-logo-container'>
        <img className='logo-img' src={this.props.logo} />
      </div>
    );
  };

  render() {
    return (
      <div className="coach-link-container">
        {this.renderHeader()}
        <div className="main-body">
            { this.renderLogo() }
            <div className="main-text">
              To get started, download the app below
            </div>
          <div className="app-stores-row">
            <img
              src={require("../../images/appStore.svg")}
              className="app-store-img"
              onClick={this.onClickApp}
            />
            <img
              src={require("../../images/googlePlay.svg")}
              className="google-play-img"
              onClick={this.onClickApp}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default CoachLink;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/CoachLink.js